import { Agent } from './agent';
import { ListingType, ListingTypeMap, SortBy } from '../classes/enums';
import { Demographics } from './demographics';
import { StreetTypes } from '../app-config.constants';
import { environment } from '../../environments/environment-wrapper';
import { ResidentialExpandedDetailSections } from './residential-expanded-detail-sections';
import { Helper } from './helper';
var Listing = /** @class */ (function () {
    function Listing(listingStub, favouriteListings, isSuggestedListing) {
        var _this = this;
        this.listingId = '';
        this.listPrice = 0;
        this.openHouses = [];
        this.virtualOpenHouses = [];
        this.sqFtSearch = 0;
        // Front end specific
        this.hasBeenViewed = false;
        this.isFavourite = false;
        // Custom properties for logic purposes
        this.isHouse = false;
        this.isTownhouse = false;
        this.isCondo = false;
        this.isCommercial = false;
        this.isHouseTownhome = false;
        this.isLeaseOrRental = false;
        this.residentialExpandedDetailSections = new ResidentialExpandedDetailSections();
        this.jsonLdSchema = [];
        this.breadcrumbSchema = [];
        if (listingStub) {
            Object.keys(listingStub).forEach(function (key) {
                _this[key] = listingStub[key];
            });
            this.fullAddress =
                [this.address, this.city, this.province].join(', ') +
                    ' ' +
                    this.postalCode;
            // Set constructor values here
            if (ListingTypeMap.house.indexOf(this.listingTypeId) >= 0) {
                this.isHouse = true;
                this.listingTypeLong = 'House';
            }
            else if (ListingTypeMap.townhouse.indexOf(this.listingTypeId) >= 0) {
                this.isTownhouse = true;
                this.listingTypeLong = 'Townhouse';
            }
            else if (ListingTypeMap.condo.indexOf(this.listingTypeId) >= 0) {
                this.isCondo = true;
                this.listingTypeLong = 'Condo';
            }
            else if (ListingTypeMap.rental.indexOf(this.listingTypeId) >= 0) {
                this.isLeaseOrRental = false;
                this.listingTypeLong = 'Rental';
            }
            else if (ListingTypeMap.house.indexOf(this.listingTypeId) !== -1 ||
                ListingTypeMap.townhouse.indexOf(this.listingTypeId) !== -1) {
                this.isHouseTownhome = true;
                this.listingTypeLong = 'Townhome';
            }
            var leaseOrRentalTypes = [
                ListingType.Rental,
                ListingType.CommercialLease,
                ListingType.Lease,
                ListingType.VacationRental
            ];
            this.isLeaseOrRental =
                leaseOrRentalTypes.indexOf(this.listingTypeId) >= 0;
            if (this.halfBaths == '0') {
                this.halfBaths = null;
            }
            if (this.baths) {
                this.totalBaths = this.halfBaths
                    ? this.baths + " + " + this.halfBaths
                    : '' + this.baths;
            }
            this.totalBeds = this.beds ? '' + this.beds : null;
            this.id = this.listingId;
            if (favouriteListings && favouriteListings.length) {
                this.isFavourite = favouriteListings.indexOf(this.listingId) >= 0;
            }
            // This little hack is needed in order to call Agent's constructor to set flag
            if (this.agent) {
                this.agent = new Agent(this.agent);
            }
            if (this.coAgent) {
                this.coAgent = new Agent(this.coAgent);
            }
            // TODO: dont need this after they update their code to remove domains
            var officeProfileUrlRegex = /https:\/\/www\.remax\.ca/g;
            this.detailUrl = this.detailUrl
                ? Helper.prependIndividualPrefix('/', this.detailUrl.replace(officeProfileUrlRegex, ''))
                : '';
            this.getFavouriteIconToUse();
            this.getVirtualTourIconToUse();
            this.getVideoIconToUse();
            this._setStreetTypeLong();
            this._setPlaceholderImage();
            this._normalizeIDXDisclosure();
            this._isFarm();
            if (ListingTypeMap.commercial.indexOf(this.listingTypeId) !== -1) {
                this.jsonLdSchema = this._setCommercialSchema(isSuggestedListing);
            }
            else {
                this.jsonLdSchema = this._setLuxuryResidentialSchema(isSuggestedListing);
            }
            if (this.hasOpenHouse) {
                var openHouseSERPs = this.openHouses.map(function (house) {
                    return {
                        '@type': 'Event',
                        description: 'Open House',
                        name: 'Open House - ' + house.timeDescription,
                        startDate: house.startTime,
                        location: {
                            '@type': 'Place',
                            name: 'Open House',
                            address: {
                                '@type': 'PostalAddress',
                                streetAddress: this.fullAddress,
                                addressLocality: this.city,
                                addressRegion: this.province,
                                postalCode: this.postalCode
                            }
                        },
                        image: this.imageUrls[0],
                        endDate: house.endTime,
                        performer: {
                            '@type': 'organization',
                            name: 'RE/MAX'
                        },
                        offers: {
                            '@type': 'Offer',
                            name: 'Open House',
                            url: environment.cdnServerUrl.slice(0, -1) + this.detailUrl,
                            price: this.listPrice,
                            validFrom: house.startTime,
                            validThrough: house.endTime,
                            priceCurrency: 'CAD',
                            availability: 'LimitedAvailability'
                        }
                    };
                }, this);
                this.jsonLdSchema[0]['@graph'] = this.jsonLdSchema[0]['@graph'].concat(openHouseSERPs);
            }
            if (this.hasVirtualOpenHouse) {
                var openHouseSERPs = this.openHouses.map(function (house) {
                    return {
                        '@type': 'Event',
                        description: 'Virtual Open House',
                        name: 'Open House - ' + house.timeDescription,
                        startDate: house.startTime,
                        location: {
                            '@type': 'Place',
                            name: 'Virtual Open House',
                            address: {
                                '@type': 'PostalAddress',
                                streetAddress: this.fullAddress,
                                addressLocality: this.city,
                                addressRegion: this.province,
                                postalCode: this.postalCode
                            }
                        },
                        image: this.imageUrls[0],
                        endDate: house.endTime,
                        performer: {
                            '@type': 'organization',
                            name: 'RE/MAX'
                        },
                        offers: {
                            '@type': 'Offer',
                            name: 'Virtual Open House',
                            url: environment.cdnServerUrl.slice(0, -1) + this.detailUrl,
                            price: this.listPrice,
                            validFrom: house.startTime,
                            validThrough: house.endTime,
                            priceCurrency: 'CAD',
                            availability: 'LimitedAvailability'
                        }
                    };
                }, this);
                this.jsonLdSchema[0]['@graph'] = this.jsonLdSchema[0]['@graph'].concat(openHouseSERPs);
            }
            this.openGraphContent = {
                bathroom: this.baths,
                bedroom: this.beds,
                area: this.sqFtSearch,
                propertyType: ListingType[this.listingTypeId],
                propertyAddress: this.fullAddress
            };
        }
        if (this.communityName &&
            this.city &&
            this.communityName.toLowerCase() === this.city.toLowerCase()) {
            this.communityName = null;
        }
    }
    Listing.prototype.setDemographics = function (data) {
        this.demographics = new Demographics(data);
    };
    Object.defineProperty(Listing.prototype, "isResidential", {
        get: function () {
            return !this.isLuxury && !this.isCommercial && !this.isOffMarket;
        },
        enumerable: true,
        configurable: true
    });
    Listing.trackBy = function (index, listing) {
        return listing.listingId;
    };
    Listing.setListingFlexOrder = function (listings) {
        for (var i = 0; i < listings.length; i++) {
            listings[i].flexOrder = 1;
        }
    };
    Listing.sortBy = function (o1, o2, sortByValue, isPricePerSqft) {
        if (isPricePerSqft === void 0) { isPricePerSqft = false; }
        switch (sortByValue) {
            case SortBy.OLDEST:
                if (o1.listingDate > o2.listingDate)
                    return 1;
                else if (o1.listingDate < o2.listingDate)
                    return -1;
                return 0;
            case SortBy.PRICE_HIGH_TO_LOW:
                if (isPricePerSqft) {
                    if (o1.pricePerSqFt < o2.pricePerSqFt)
                        return 1;
                    else if (o1.pricePerSqFt > o2.pricePerSqFt)
                        return -1;
                    return 0;
                }
                else {
                    if (o1.listPrice < o2.listPrice)
                        return 1;
                    else if (o1.listPrice > o2.listPrice)
                        return -1;
                    return 0;
                }
            case SortBy.PRICE_LOW_TO_HIGH:
                if (isPricePerSqft) {
                    if (o1.pricePerSqFt > o2.pricePerSqFt)
                        return 1;
                    else if (o1.pricePerSqFt < o2.pricePerSqFt)
                        return -1;
                    return 0;
                }
                else {
                    if (o1.listPrice > o2.listPrice)
                        return 1;
                    else if (o1.listPrice < o2.listPrice)
                        return -1;
                    return 0;
                }
            default:
                if (o1.listingDate < o2.listingDate)
                    return 1;
                else if (o1.listingDate > o2.listingDate)
                    return -1;
                return 0;
        }
    };
    /**
     * this is used on the favourites gallery where you may have listings that have price per sqft mixed
     * with listings that have regular price
     * @param {Listing} o1
     * @param {Listing} o2
     * @param {SortBy} sortByValue
     */
    Listing.sortByMixed = function (o1, o2, sortByValue) {
        var priceO1 = o1.pricePerSqFt ? o1.pricePerSqFt : o1.listPrice;
        var priceO2 = o2.pricePerSqFt ? o2.pricePerSqFt : o2.listPrice;
        switch (sortByValue) {
            case SortBy.OLDEST:
                if (o1.listingDate > o2.listingDate)
                    return 1;
                else if (o1.listingDate < o2.listingDate)
                    return -1;
                return 0;
            case SortBy.PRICE_HIGH_TO_LOW:
                if (priceO1 < priceO2)
                    return 1;
                else if (priceO1 > priceO2)
                    return -1;
                return 0;
            case SortBy.PRICE_LOW_TO_HIGH:
                if (priceO1 > priceO2)
                    return 1;
                else if (priceO1 < priceO2)
                    return -1;
                return 0;
            default:
                if (o1.listingDate < o2.listingDate)
                    return 1;
                else if (o1.listingDate > o2.listingDate)
                    return -1;
                return 0;
        }
    };
    Listing.prototype.getFavouriteIconToUse = function () {
        this.favouriteIconToUse = this.isFavourite
            ? '/assets/icons/heart/heart_icon_red@2x.svg'
            : this.isCommercial || this.isLuxury
                ? this.isLuxury
                    ? '/assets/icons/heart/heart_icon_white@2x.svg'
                    : '/assets/icons/heart/heart_icon_commercial.svg'
                : '/assets/icons/heart/heart_icon_accessible@2x.svg';
    };
    Listing.prototype.getVideoIconToUse = function () {
        this.videoIconToUse = this.isCommercial
            ? '/assets/icons/listing-details/more-to-see/video_icon_red_t@1x.svg'
            : this.isLuxury
                ? '/assets/icons/listing-details/more-to-see/video_icon_white_t@1x.svg'
                : '/assets/icons/listing-details/more-to-see/video_icon_blue_t@1x.svg';
    };
    Listing.prototype.getVirtualTourIconToUse = function () {
        this.virtualTourIconToUse = this.isCommercial
            ? '/assets/icons/listing-details/more-to-see/virtual_tour_icon_red_t2@1x.svg'
            : this.isLuxury
                ? '/assets/icons/listing-details/more-to-see/virtual_tour_icon_white_t2@1x.svg'
                : '/assets/icons/listing-details/more-to-see/virtual_tour_icon_blue_accessible_t2@1x.svg';
    };
    /*
     * The content of idxDisclosure attribute contains html tags and some programming langugage related functions
     * The method removes html tags from string and replaces multiple spaces with single one also replaces @Year@ with current year
     * and @State@ with two character province name
     */
    Listing.prototype._normalizeIDXDisclosure = function () {
        if (this.idxDisclosure) {
            // To remove html tags,  Copyright and ©
            var htmlTagRegex = RegExp('<[^>]*>|$', 'g');
            // Replace string '@Year@' with value of current year
            var currentYearRemax = RegExp('@Year@', 'g');
            // To replace multiple spaces with a single one
            var singleSpaceRegex = RegExp('\\s{2,}', 'g');
            // To replace string '@State@' with actual province name
            var province = RegExp('@State@', 'g');
            this.idxDisclosure = this.idxDisclosure
                .replace(htmlTagRegex, '')
                .replace(singleSpaceRegex, ' ')
                .replace(currentYearRemax, String(new Date().getFullYear()))
                .replace(province, this.province)
                .trim();
        }
    };
    Listing.prototype._setStreetTypeLong = function () {
        // Regex to grab the street type (RD, AVE, etc, second last or last word in address)
        var streetTypeRegex = /^(.*?)([a-zA-Z]+)(\s(N|E|S|W){1,2})?\s*$/;
        var streetTypeShort = streetTypeRegex.exec(this.address);
        // Checks if address has a street type
        if (streetTypeShort && streetTypeShort[2] && streetTypeShort[2] !== "") {
            // Checks if street type abbreviation is in mapping
            if (StreetTypes[streetTypeShort[2].toUpperCase()]) {
                var streetTypeLong = StreetTypes[streetTypeShort[2].toUpperCase()];
                // Replaces short street type with long street type (AVE -> Avenue) and adds direction 
                this.streetTypeLongAddress = this.address.replace(streetTypeRegex, "$1" + streetTypeLong + "$3");
            }
            else {
                // Normalize the short street type and return it capitalized (ie. AVEnue -> Avenue or STReet -> Street)
                var normalizedStreetType = streetTypeShort[2].charAt(0).toUpperCase() + streetTypeShort[2].slice(1).toLowerCase();
                this.streetTypeLongAddress = this.address.replace(streetTypeRegex, "$1" + normalizedStreetType + "$3");
            }
        }
        else {
            this.streetTypeLongAddress = this.address;
        }
    };
    // [MBL-3844] - Getting Property Type based on listingTypeId
    Listing.prototype._getPropertyType = function (listingTypeId, isSuggestedListing) {
        if (!isSuggestedListing &&
            ListingType.Condo.valueOf() === this.listingTypeId)
            return 'Apartment';
        return 'House';
    };
    Listing.prototype._isFarm = function () {
        if (ListingType.Farm.valueOf() === this.listingTypeId) {
            this.isFarm = true;
            this.primaryBusinessType = 'Farm';
        }
        else {
            this.isFarm = false;
        }
    };
    Listing.prototype._setPlaceholderImage = function () {
        if (this.isCommercial)
            this.placeHolderImage =
                '/assets/listing-default-image/commercial_placeholder_v2@1x.svg';
        else if (this.isLuxury)
            this.placeHolderImage =
                '/assets/listing-default-image/luxury_placeholder_v2@1x.svg';
        else
            this.placeHolderImage =
                '/assets/listing-default-image/residential_placeholder_v2@1x.svg';
    };
    Listing.prototype._setCommercialSchema = function (isSuggestedListing) {
        return [
            {
                '@context': 'http://schema.org',
                '@graph': [
                    {
                        '@type': 'Offer',
                        price: this.listPrice,
                        priceCurrency: 'CAD',
                        url: this.detailUrl
                    }
                ]
            }
        ];
    };
    Listing.prototype._setLuxuryResidentialSchema = function (isSuggestedListing) {
        return [
            {
                '@context': 'http://schema.org',
                '@graph': [
                    {
                        '@type': 'SingleFamilyResidence',
                        address: {
                            '@type': 'PostalAddress',
                            streetAddress: this.fullAddress,
                            addressLocality: this.city,
                            addressRegion: this.province,
                            postalCode: this.postalCode
                        },
                        geo: {
                            '@type': 'GeoCoordinates',
                            latitude: this.lat,
                            longitude: this.lng
                        }
                    },
                    {
                        '@type': this._getPropertyType(this.listingTypeId, isSuggestedListing),
                        numberOfRooms: this.rooms,
                        address: {
                            '@type': 'PostalAddress',
                            streetAddress: this.fullAddress,
                            addressLocality: this.city,
                            addressRegion: this.province,
                            postalCode: this.postalCode
                        },
                        geo: {
                            '@type': 'GeoCoordinates',
                            latitude: this.lat,
                            longitude: this.lng
                        },
                        description: this.description,
                        photo: {
                            '@type': 'ImageObject',
                            url: this.imageUrls
                        }
                    },
                    {
                        '@type': 'Offer',
                        price: this.listPrice,
                        priceCurrency: 'CAD',
                        url: this.detailUrl
                    }
                ]
            }
        ];
    };
    return Listing;
}());
export { Listing };
export var FlagType;
(function (FlagType) {
    FlagType["COMING_SOON"] = "Coming Soon";
})(FlagType || (FlagType = {}));
